import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthService } from '@services/auth.service';
import { ChefFooterModule } from 'chef-common/src/lib/chef-footer';
import { ChefHeaderModule } from 'chef-common/src/lib/chef-header';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { ChefLoaderModule } from 'chef-common/src/lib/chef-loader';
import { AgeModalComponent } from '@modals/age-modal/age-modal.component';

import { ToastrModule } from 'ngx-toastr';
import { NgxStripeModule } from 'ngx-stripe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ChefMessageModule } from 'chef-common/src/lib/chef-message';
import { BackToTopComponent } from '@components/back-to-top/back-to-top.component';

export function initConfig(auth: AuthService) {
  return () => auth.getSiteData();
}
@NgModule({
  declarations: [
    AppComponent,
    AgeModalComponent,
    BackToTopComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ChefHeaderModule,
    ChefFooterModule,
    NgxSpinnerModule,
    ChefLoaderModule,
    ChefMessageModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      maxOpened: 1,
      autoDismiss: true,
      closeButton: true
    }),
    NgxStripeModule.forRoot(),
    NgbModalModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AuthService],
      multi: true,
    },
    Title,
    NgbActiveModal
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
